import { FaHeadset, FaCommentDots } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemChamado = ({ notif, onClick }) => {
    const info = notif.chamado_info;
    if (!info) return null;

    const isResposta = info.mensagem_resposta;
    const dataRaw = info.data_abertura; 
    
    let dataFormatada = "";
    if (dataRaw) {
        if (dataRaw.includes('/')) {
            dataFormatada = dataRaw;
        } else {
            try {
                const data = new Date(dataRaw);
                dataFormatada = data.toLocaleString("pt-BR", {
                    day: "2-digit", month: "2-digit", year: "numeric",
                    hour: "2-digit", minute: "2-digit",
                });
            } catch (e) { dataFormatada = dataRaw; }
        }
    }

    return (
        <DropdownItemBase
            icon={isResposta ? <FaCommentDots /> : <FaHeadset />}
            text={isResposta ? "text-info" : "text-success"}
            titulo={isResposta ? `Atualização Chamado #${info.numero}` : `Novo Chamado #${info.numero}`}
            descricao={isResposta ? "Verifique as atualizações." : `Por: ${info.solicitante_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemChamado;
